import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import web5 from "../img/bakery.jpg";
import "../style/styles.css";
import "../style/Bakery.css";

const Bakery = () => {
  let alText = "Photo";

  const quickStats = [
    { value: "POS", label: "Bakery Billing" },
    { value: "Stock", label: "Inventory Control" },
    { value: "Recipe", label: "Production Control" },
    { value: "SMS", label: "Customer Alerts" },
  ];

  const keyModules = [
    {
      title: "Key Features of BakeryPro",
      text:
        "BakeryPro is integrated software for bakery industries. It provides features for bakeries and chains to maximize operational efficiency and customer engagement.",
    },
    {
      title: "Bakery POS",
      text:
        "Touch-screen, scan and barcode technology helps speed up billing and transactions. Order management to delivery is supported through the bakery POS module.",
    },
    {
      title: "Inventory Control",
      text:
        "Manage ingredients, raw materials, intermediaries and finished products from reception to production and from production to transport with full visibility.",
    },
    {
      title: "Cost Effective",
      text:
        "Inventory and stock management helps monitor raw materials, receive shortage notifications and determine food costs for accurate costing.",
    },
    {
      title: "Recipe Management",
      text:
        "Automates recipe formulation and inventory management to improve product consistency, weight control, ingredient tracking and recipe traceability.",
    },
    {
      title: "Accounting, SMS & Payroll",
      text:
        "Manage branch accounting, head office accounting, SMS integration for customer alerts and payroll processing for bakery staff and workers.",
    },
  ];

  const featureBlocks = [
    {
      title: "Key Features of BakeryPro",
      text:
        "BakeryPro is integrated software for Bakery Industries. His provides a multitude of features for bakeries and chains to maximize their operational efficiency and customer engagement! Everything from order management to delivery is fully supported by our system. The operations become more systematically",
    },
    {
      title: "Bakery POS",
      text:
        "Selling your baked goods on the ground has never been easier. The bakery POS software uses the latest touch-screen, scan and barcode technologies to speed up transactions wherever your customers are. Everything from order management to delivery is managed by the bakery POS module. Operations become more organized, take less time and systematically.",
    },
    {
      title: "Inventory Control",
      text:
        "The inventory covers the management of ingredients and raw materials from reception to production and the management of intermediaries and finished products from production to transport. Inventory records are monitored and updated using numerous BatchMaster processes for their quality control facilities, weights, quantities and units of measure, as well as factory locations and licenses. Product developers see inventory costs when they add ingredients and materials to formulas and assemblies, respectively. Production staff can divide the best warehouse into batch jobs, adjust warehouse properties, and move the warehouse from one location to another or between facilities. In addition, the producers record the actual income from the batches, including the quality assurance items per batch produced. In addition, management has full visibility into all inventory changes and inventory levels based on different inventory characteristics, including a simultaneous view of weight, quantity and quantity in different units of measure.",
    },
    {
      title: "Cost Effective",
      text:
        "Have you ever wondered how the ingredients for the Valentine Chocolate were recovered so early? This is because your customers love it and will keep coming back to find out more. And honestly, nobody likes to read \"not available\" written next to their preferred choice. The inventory and inventory management software on your bakery's point of sale system will help you manage all the raw materials. It will notify you immediately when you run out of ingredient. Inventory management helps you determine your food costs. Without this, your calculations are never precise.",
    },
    {
      title: "Recipe Management",
      text:
        "Manual baking processes are very common in small independent bakeries, especially for weighing ingredients; however, this can lead to inaccurate recipes, inconsistencies in the finished products, and even production errors. Therefore, to ensure product consistency, weight control, ingredient and recipe traceability for the baking industries, BakeryPro controlled the production raw materials that automate recipe formulation and inventory management.",
    },
    {
      title: "Accounting",
      text:
        "Finance and accounting software helps in regular tracking of your bakery’s sale and expenses. Stock purchase and inventory management become simplified. Better insight is gained on profitable and best-selling items, profits and much more. BakeryPro is an integrated software where you can manage branch accounting separated and also integrated with head office accounting.",
    },
    {
      title: "SMS Integration",
      text:
        "SMS Integration BakeryPro has powerful SMS integration to promote your business in the competitive business world. And also alert to customer for their order and connect in every occasion by our sms integration.",
    },
    {
      title: "Payroll",
      text:
        "In bakery Industries, there should be strong systematically attendance system. In BakeryPro, there are several way to make attendance by the staff and worker. From behind-the-counter-staff, to bakers, to janitorial staff, you must ensure that your employees are paid on time. Rather than manually preparing payroll, you can instead rely on our Payroll integrated system in BakeryPro is designed to make processing payroll for your bakery easier and faster.",
    },
  ];

  const overviewItems = [
    "Order management to delivery",
    "Touch-screen POS",
    "Scan and barcode technologies",
    "Inventory and raw material control",
    "Recipe formulation",
    "Accounting",
    "SMS Integration",
    "Payroll",
  ];

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="bakery-detail-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          BakeryPro - GST Enabled Web Application for Bakery Management | EBS Software Solution
        </title>
        <meta
          name="description"
          content="BakeryPro is a GST enabled web application for bakery management with bakery POS, inventory control, cost effective stock management, recipe management, accounting, SMS integration and payroll."
        />
      </Helmet>

      <section className="bakery-hero">
        <img
          className="bakery-hero-bg"
          src={web5}
          alt={alText}
          onError={handleImageError}
        />
        <div className="bakery-hero-overlay"></div>

        <Container className="bakery-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="bakery-hero-content">
                <div className="bakery-kicker">Bakery Management Software</div>
                <h1>BakeryPro</h1>
                <h2>GST Enabled Web Application for Bakery Management</h2>
                <p>
                  BakeryPro is integrated software for Bakery Industries. His
                  provides a multitude of features for bakeries and chains to
                  maximize their operational efficiency and customer engagement!
                  Everything from order management to delivery is fully supported
                  by our system. The operations become more systematically
                </p>

                <div className="bakery-hero-actions">
                  <a href="#bakery-modules" className="bakery-btn bakery-btn-primary">
                    View Features
                  </a>
                  <Link to="/EmailContactForm" className="bakery-btn bakery-btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="bakery-highlight-card">
                <span>Integrated Bakery Solution</span>
                <strong>POS + Inventory + Recipe + Accounting</strong>
                <p>
                  Designed for bakeries and chains to organize billing,
                  production, ingredients, delivery, SMS and payroll workflow.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="bakery-stats-section">
        <Container>
          <Row className="g-3">
            {quickStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="bakery-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="bakery-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="bakery-section-label">Overview</div>
              <h2 className="bakery-section-title">
                Integrated software for bakery industries
              </h2>
              <p className="bakery-text">
                BakeryPro provides a multitude of features for bakeries and
                chains to maximize their operational efficiency and customer
                engagement. Everything from order management to delivery is fully
                supported by the system.
              </p>
              <p className="bakery-text">
                It helps manage bakery POS, inventory control, cost effective
                stock planning, recipe management, accounting, SMS integration
                and payroll from one organized bakery management platform.
              </p>
            </Col>

            <Col lg={6}>
              <div className="bakery-overview-card">
                <h3>BakeryPro covers</h3>
                <div className="bakery-overview-grid">
                  {overviewItems.map((item) => (
                    <div key={item}>
                      <span>✓</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="bakery-modules-section" id="bakery-modules">
        <Container>
          <div className="bakery-heading-center">
            <div className="bakery-section-label">Key Modules</div>
            <h2 className="bakery-section-title">
              Complete bakery workflow from POS to payroll
            </h2>
            <p>
              BakeryPro connects order management, delivery, bakery POS,
              inventory, costing, recipe management, accounting, SMS and payroll
              into one professional bakery management system.
            </p>
          </div>

          <Row className="g-4">
            {keyModules.map((module, index) => (
              <Col lg={4} md={6} key={module.title}>
                <div className="bakery-module-card">
                  <div className="bakery-module-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="bakery-feature-list-section">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="bakery-info-card">
                <div className="bakery-section-label">Bakery POS</div>
                <h2>Touch-screen, scan and barcode enabled POS</h2>
                <p>{featureBlocks[1].text}</p>
              </div>
            </Col>

            <Col lg={6}>
              <div className="bakery-info-card bakery-info-card-dark">
                <div className="bakery-section-label">Inventory Control</div>
                <h2>Ingredients, raw materials and finished product control</h2>
                <p>{featureBlocks[2].text}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="bakery-feature-list-section bakery-feature-list-alt">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="bakery-info-card">
                <div className="bakery-section-label">Cost Effective</div>
                <h2>Better stock and food cost control</h2>
                <p>{featureBlocks[3].text}</p>
              </div>
            </Col>

            <Col lg={6}>
              <div className="bakery-info-card">
                <div className="bakery-section-label">Recipe Management</div>
                <h2>Recipe formulation and ingredient traceability</h2>
                <p>{featureBlocks[4].text}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="bakery-business-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={5}>
              <div className="bakery-business-title">
                <div className="bakery-section-label">Business Control</div>
                <h2 className="bakery-section-title">
                  Accounting, SMS integration and payroll
                </h2>
                <p>
                  BakeryPro helps in regular tracking of bakery sales, expenses,
                  stock purchase, inventory, profitable items, customer alerts
                  and employee payroll processing.
                </p>
              </div>
            </Col>

            <Col lg={7}>
              <div className="bakery-business-grid">
                {featureBlocks.slice(5).map((item) => (
                  <div key={item.title}>
                    <span>✓</span>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="bakery-cta-section">
        <Container>
          <div className="bakery-cta-card">
            <div>
              <span>Ready to modernize your bakery operations?</span>
              <h2>Use BakeryPro for POS, inventory, recipe and accounts.</h2>
              <p>
                Get a GST enabled bakery management web application with order
                management, delivery, inventory, recipe, accounting, SMS and
                payroll workflow.
              </p>
            </div>
            <Link to="/EmailContactForm" className="bakery-btn bakery-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Bakery;
